import { ExchangedMonetaryValueBackend, ExchangedMonetaryValueBackendConvertedMVOnlyDTO } from '@luminovo/http-client';
import { formatCurrency } from '../../../../utils/currencyUtils';

export const renderCostContent = (
    costs: ExchangedMonetaryValueBackend | ExchangedMonetaryValueBackendConvertedMVOnlyDTO | undefined,
): string => {
    return costs === undefined ? '-' : formatCurrency(costs.converted_mv.amount, costs.converted_mv.currency);
};
